import { render, staticRenderFns } from "./account.vue?vue&type=template&id=0d894045&"
import script from "./account.vue?vue&type=script&lang=js&"
export * from "./account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d894045')) {
      api.createRecord('0d894045', component.options)
    } else {
      api.reload('0d894045', component.options)
    }
    module.hot.accept("./account.vue?vue&type=template&id=0d894045&", function () {
      api.rerender('0d894045', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/account.vue"
export default component.exports